export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            关于我们
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            了解蚂蚁影视的初心与愿景
          </p>
        </div>

        <div className="bg-background-50 border border-background-300/30 rounded-xl p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-950 text-lg"></i>
            </div>
            <h3 className="text-lg font-bold text-foreground-50 font-heading">
              蚂蚁影视
            </h3>
          </div>

          <div className="space-y-4 text-sm text-foreground-400 leading-relaxed">
            <p>
              蚂蚁影视成立于2023年，是国内领先的高清免费在线观影平台。我们致力于为全球华语用户提供最便捷、最流畅的影视观看体验，让每一个人都能轻松享受高品质的影视内容。
            </p>
            <p>
              平台汇聚了超过5万部电影、电视剧、综艺、动漫和纪录片资源，覆盖院线新片、经典老片、热播剧集等全品类内容。通过自研的智能CDN加速引擎，蚂蚁影视实现了1080P甚至4K画质下的流畅播放，让"不缓冲追剧"成为现实。
            </p>
            <p>
              我们相信，好的内容应该被更多人看到。蚂蚁影视始终坚持免费模式，让用户无需付费即可享受高品质观影体验。同时，我们也在积极扶持原创内容创作，为青年导演提供展示才华的舞台。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-xl font-bold text-primary-400 font-heading">50000+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-xl font-bold text-primary-400 font-heading">2000万+</div>
              <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-xl font-bold text-primary-400 font-heading">每日更新</div>
              <div className="text-xs text-foreground-500 mt-1">200+资源</div>
            </div>
            <div className="text-center p-4 bg-background-100 rounded-xl">
              <div className="text-xl font-bold text-primary-400 font-heading">全终端</div>
              <div className="text-xs text-foreground-500 mt-1">无缝覆盖</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}